<template>
    <span class="text-danger">{{ text }}</span>
</template>

<script>

import {dateFormat, daysHoursUntilDateTime, timeFormat} from "../../../Utility/filters/dates"
import {money} from '../../../Utility/filters/money'

export default {
    name: "Price",
    props: {
        price: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    filters: {
        dateFormat,
        daysHoursUntilDateTime,
        money,
        timeFormat,
    },
    computed: {
        text() {
            if (this.price.capacity !== null && this.price.effective_from !== null) {
                return `Price rises in ${this.$options.filters.daysHoursUntilDateTime(this.price.effective_from)} or after ${this.price.capacity} entries`;
            } else if (this.price.capacity !== null) {
                return `Price rises after ${this.price.capacity} tickets sold`;
            } else {
                return `Price rises in ${this.$options.filters.daysHoursUntilDateTime(this.price.effective_from)}`;
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/NextPriceText.vue